import script from "./CustomCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCard.vue?vue&type=script&setup=true&lang=js"

import "./CustomCard.vue?vue&type=style&index=0&id=5fb18926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb18926"]])

export default __exports__